module.exports = __webpack_public_path__ + "images/menu-dashboard.svg?7101b4a5b97ceda06b9eeab057e9b6dc";